// アニメーションのイージング周り
const animTiming = {
  duration: 300,
  easing: 'ease-out',
};

// アコーディオンと閉じる時のアニメーション
const closingAnim = (content: any): Keyframe[] => {
  return [
    {
      height: content.offsetHeight + 'px',
    },
    {
      height: 0,
    },
  ];
};

// アコーディオンを開く時のアニメーション
const openingAnim = (content: any): Keyframe[] => {
  return [
    {
      height: 0,
    },
    {
      height: content.offsetHeight + 'px',
    },
  ];
};

window.addEventListener('DOMContentLoaded', () => {
  // detail要素を取得
  const accordion = document.querySelectorAll(
    '[data-acc="true"]'
  ) as NodeListOf<HTMLDetailsElement>;

  // アニメーション中かどうかのフラグ
  const RUNNING = 'running';
  const IS_OPEN = 'is-open';

  accordion.forEach((el) => {
    const accordionContent = el.querySelector('[data-accContent="true"]')!;
    const accordionContentTitle = el.querySelector('[data-accTitle="true"]')!;

    accordionContentTitle.addEventListener('click', (event) => {
      event.preventDefault();

      // アニメーション中は何もしない
      if (el.dataset.status === RUNNING) return;

      // アコーディオンが開いているかどうか
      if (el.open) {
        el.classList.toggle(IS_OPEN);

        // アニメーションの実行
        const closing = accordionContent.animate(
          closingAnim(accordionContent),
          animTiming
        );
        el.dataset.status = RUNNING;

        closing.onfinish = () => {
          el.removeAttribute('open');
          el.dataset.status = '';
        };
      } else {
        el.setAttribute('open', 'true');
        el.classList.toggle(IS_OPEN);

        // アニメーションの実行
        const opening = accordionContent.animate(
          openingAnim(accordionContent),
          animTiming
        );
        el.dataset.status = RUNNING;

        opening.onfinish = () => {
          el.dataset.status = '';
        };
      }
    });
  });
});
